import { gql } from '@apollo/client';

export const registerSupplierMutation = gql`
  mutation registerSupplier($supplierRegister: SupplierRegisterInput!) {
    registerSupplier(RegisterSupplierInput: $supplierRegister) {
      message
    }
  }
`;
